// FloatingContactButton.js
import React from "react";
import "./FloatingContactButton.css";

const FloatingContactButton = ({ scrollToConsult }) => {
  return (
    <>
      <a type="button" className="floating-contact-button bg-golden cursor-pointer" onClick={scrollToConsult} >
        <div className="mt-1 d-flex align-items-center justify-content-start cursor-pointer">
          <span className="icon ms-2">
            <lord-icon
                src="https://cdn.lordicon.com/vpbspaec.json"
                trigger="loop"
                delay="1500"
                state="in-unfold"
                colors="primary:#ffffff,secondary:#fff"
                style={{width: '40px', height: '40px'}}>
            </lord-icon>
          </span>
          <span className="fs-18 text ms-3">Get in Touch</span>
        </div>
      </a>
    </>
  );
};

export default FloatingContactButton;
